const React = require('react')
const PropTypes = require('prop-types')
const SmallImage = require('module/profile_view/templates/small_image')
const log = require('log').create('viewer button') // eslint-disable-line

function ViewerButton(props, context) {
    const { viewer } = context

    return (
        <li>
            <a
                href="/user/edit"
                className="viewer-button"
                data-metric-channel="metrics_nav"
                data-metric-event="clicked:viewer:button"
                >
                <SmallImage user={viewer} width={40} height={40} />
                <div className="gear" />
            </a>
        </li>
    )
}

ViewerButton.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = ViewerButton
